import { em } from 'polished'

import CSSPlugin from 'gsapAlias/CSSPlugin'
import { Power0 } from 'gsapAlias/EasePack'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

import { calcDnaBarWidth } from '../utils'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const timeline = ({
  wgsText,
  wgsBar,
  wgsBox,
  dnaText,
  dnaBar,
  dnaBox,
}) => {
  const tl = new TimelineLite({ paused: true })

  tl.add([
    TweenLite.to([wgsBox, dnaBox], 0.6, { alpha: 1, y: 0 }),
    TweenLite.from([wgsBar, dnaBar], 0.6, { width: '0%', alpha: 0 }),
    TweenLite.to([wgsText, dnaText], 0.3, { alpha: 1, delay: 0.3 }),
  ])

  return tl
}

export const diffsTranslate = ({ diffsRef, offset }) =>
  TweenLite.to(diffsRef.current, 1, {
    y: -offset,
    ease: Power0.easeNone,
  })

export const barsChangeState = ({ wgsBar, dnaBar, wgsText, dnaText, data }) => {
  TweenLite.to([wgsText, dnaText], 0.3, {
    transform: `translateY(${em(50)})`,
    alpha: 0,
  })
  TweenLite.to([wgsText, dnaText], 0.3, {
    transform: `translateY(${em(20)})`,
    alpha: 1,
  }).delay(0.6)
  TweenLite.to([wgsBar, dnaBar], 0.6, { width: '0%' })
  TweenLite.to(wgsBar, 0.6, { width: '100%' }).delay(0.7)
  TweenLite.to(dnaBar, 0.6, {
    width: `${calcDnaBarWidth(data.wgs_indicators, data.dna_indicators)}%`,
  }).delay(0.7)
}
